import { useEffect, useState } from 'react'

//material-ui
import { Autocomplete, Grid, TextField, Typography } from '@mui/material'

//project import
import { useApiData } from 'services/hook/useApiData'

const DynamicAutocomplete = ({ setFieldValue, initialValue, fetchList, fieldName }) => {
    const [value, setValue] = useState(initialValue ?? null);
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);

    const [data, , loading, loadData] = useApiData([], {}, (params, setData) => {
        fetchList(inputValue) 
            .then((res) => {
                setData(res.data)
            })
            .catch((res) => {
                console.log(res)
            })
    }, false)

    useEffect(() => {
        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }
    }, [value, inputValue]);

    useEffect(() => {
        if (initialValue && typeof initialValue === 'number') {
            loadData(true);
        } else if (initialValue && typeof initialValue === 'object') {
            setValue(initialValue);
        } else {
            setValue(null);
        }
    }, [initialValue]);

    useEffect(() => {
        if (initialValue && typeof initialValue === 'number' && data.length > 0) {
            const foundCountry = data.find(role => role.id === initialValue);
            if (foundCountry) {
                setValue(foundCountry);
            }
        }
    }, [data, initialValue]);

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue); 
        loadData(true);
    };

    const getLabel = (option) => {
        if (!option) {
            return ''
        }
        return option.name
    }
    
    return (
        <Autocomplete 
            id="user"
            className='custom_autocomplete'
            getOptionLabel={(option) => getLabel(option)}
            filterOptions={(x) => x}
            options={data}
            loading={loading}
            value={value}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            autoComplete
            includeInputInList
            filterSelectedOptions
            noOptionsText="No Data"
            onChange={(event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                setFieldValue(fieldName, newValue);
            }}
            onOpen={() => {
                loadData(true);
            }}
            onInputChange={handleInputChange}
            renderInput={(params) => (
                <TextField {...params} placeholder="Select option" fullWidth />
            )}
            renderOption={(props, option) => {
                const { key, ...rest } = props;
                return (
                    <li key={key} {...rest}>
                        <Grid container alignItems="center">
                            <Grid item sx={{ wordWrap: 'break-word' }}>
                                <Typography >
                                    {getLabel(option)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </li>
                );
            }}
        />
    )
}

export default DynamicAutocomplete